import React, { memo, useRef, useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ReactComponent as CloseIcon } from "@assets/svg/close.svg";
import { bankExtractionCopy } from "@investorRequest/constants/bankExtractionCopy";

interface Props {
  filename: string;
  dismissed: boolean;
  onDismiss: () => void;
}

const BankExtractionPrefillBanner = ({ filename, dismissed, onDismiss }: Props) => {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bannerRef.current?.focus();
  }, []);

  if (dismissed) return null;

  return (
    <Box
      ref={bannerRef}
      tabIndex={-1}
      role="region"
      aria-label="Pre-fill notice"
      data-testid="bank-extraction-prefill-banner"
      sx={{
        bgcolor: "accent.main",
        borderLeft: "4px solid",
        borderColor: "warning.main",
        p: 2,
        mb: 3,
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
      }}
    >
      <Box component="span" aria-hidden sx={{ fontSize: 20 }}>
        ✨
      </Box>
      <Typography variant="body1" flex={1}>
        {bankExtractionCopy.prefillBanner(filename)}
      </Typography>
      <IconButton
        size="small"
        aria-label="Dismiss pre-fill notice"
        onClick={onDismiss}
        onKeyDown={(event) => {
          if (event.key === "Escape") onDismiss();
        }}
      >
        <CloseIcon width={16} height={16} />
      </IconButton>
    </Box>
  );
};

export default memo(BankExtractionPrefillBanner);
